import * as React from 'react';
import { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import * as yup from 'yup';
import LoadingButton from '../lowLevel/LoadingButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  fieldContainer: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.brand.greyCyan}`,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  submit: {
    margin: '0px auto',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textColor: {
    color: 'black',
  },
}));

const passwordValidation = yup
  .string()
  .min(8, 'Password needs at least 8 characters')
  .matches(/[A-Z]/, 'Must contain at least one capital letter')
  .matches(/[a-z]/, 'Must contain at lease one lower case letter')
  .matches(/\d/, 'Must contain at least one digit')
  .required('Password is required');

export default function ChangePasswordForm({
  onSubmit,
  error,
  signedIn = false,
}) {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const classes = useStyles({ signedIn });

  return (
    <Formik
      validationSchema={yup
        .object({
          password: passwordValidation,
          confirmPassword: passwordValidation,
          oldPassword: !signedIn ? yup.string() : passwordValidation,
        })
        .test('passwords-match', 'null', (values) => {
          if (values.password !== values.confirmPassword) {
            return new yup.ValidationError(
              'Passwords do not match.',
              null,
              'confirmPassword',
            );
          }
        })}
      initialValues={{ password: '', confirmPassword: '', oldPassword: '' }}
      onSubmit={({ password, oldPassword }) => onSubmit(password, oldPassword)}
    >
      {({ isSubmitting }) => (
        <Form className={classes.root}>
          {signedIn && (
            <div>
              <InputLabel
                className={classes.textColor}
                shrink
                htmlFor="bootstrap-input"
              >
                Current password
              </InputLabel>
              <Field
                className={`${classes.fieldContainer} `}
                component={TextField}
                variant={signedIn ? 'outlined' : 'standard'}
                name="oldPassword"
                type={showOldPassword ? 'text' : 'password'}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={() => setShowOldPassword(!showOldPassword)}
                      >
                        {showOldPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}
          <div>
            <InputLabel
              className={classes.textColor}
              shrink
              htmlFor="bootstrap-input"
            >
              new password
            </InputLabel>
            <Field
              className={` ${classes.fieldContainer} `}
              component={TextField}
              variant={signedIn ? 'outlined' : 'standard'}
              name="password"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div>
            <InputLabel
              className={classes.textColor}
              shrink
              htmlFor="bootstrap-input"
            >
              Confirm new password
            </InputLabel>
            <Field
              className={` ${classes.fieldContainer} `}
              component={TextField}
              variant={signedIn ? 'outlined' : 'standard'}
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <FormHelperText style={{ textAlign: 'center' }} error>
            {error}
          </FormHelperText>
          <LoadingButton
            className={classes.submit}
            loading={isSubmitting}
            type="submit"
          >
            Submit
          </LoadingButton>
        </Form>
      )}
    </Formik>
  );
}
